import styled from 'styled-components';

const TEXT_PRIMARY = '#121212';
const TEXT_SECONDARY = 'rgba(18, 18, 18, 0.6)';
const DIVIDER = 'rgba(18, 18, 18, 0.12)';
const UPCOMING = '#2f7ed8';

export const CaseloadContent = styled.div`
  padding: 8px 8px 4px;

  .caseload-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: ${TEXT_PRIMARY};
  }
  .caseload-subtitle {
    margin: 4px 0 16px;
    font-size: 13px;
    color: ${TEXT_SECONDARY};
  }
  .caseload-empty {
    margin: 0 0 16px;
    font-size: 14px;
    color: ${TEXT_SECONDARY};
  }

  .caseload-table {
    width: 100%;
    border-collapse: collapse;
  }
  .caseload-table th {
    text-align: left;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: ${TEXT_SECONDARY};
    padding: 0 8px 6px 0;
    border-bottom: 1px solid ${DIVIDER};
  }
  .caseload-table td {
    vertical-align: top;
    padding: 10px 8px 10px 0;
    border-bottom: 1px solid ${DIVIDER};
  }
  /* Keep the day/time column from squeezing the client column. */
  .caseload-table th:last-child,
  .caseload-table td:last-child {
    width: 55%;
  }
  /* Indent the number column so it is not flush against the modal edge, and
     right-align the digits so 1 and 12 share a common edge. */
  .caseload-table .row-number {
    width: 44px;
    padding-left: 8px;
    padding-right: 16px;
    text-align: right;
    color: ${TEXT_SECONDARY};
    font-size: 13px;
    font-variant-numeric: tabular-nums;
  }

  .client-name {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: ${TEXT_PRIMARY};
  }
  .client-dob {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${TEXT_SECONDARY};
  }
  .session-list {
    display: block;
    font-size: 14px;
    color: ${TEXT_PRIMARY};
  }
  .session-upcoming {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    font-weight: 600;
    color: ${UPCOMING};
  }

  .caseload-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
`;
